import { OIDC_STORE_PREFIX, RUNNING, TSG_ID_NONE } from '../../framework/constants'
import { getDatadogRum } from '../../framework/externals'
import { stateRef } from '../../framework/store'
import { __isLocalhost } from '../../init/debug'

export const isNoneTsg = () => {
  const tsgId = stateRef.current.auth?.tsg_id
  return tsgId === TSG_ID_NONE
}

export const globalAvail = () => {
  const tsgId = stateRef.current.auth?.tsg_id
  return !tsgId || tsgId !== TSG_ID_NONE
}

export const noTsgAccess = () => Boolean(stateRef.current.auth?.access?.noRoleAccess)
export const isIPRestricted = () => Boolean(stateRef.current.auth?.instances?.error?.ipRestricted)
export const noRunningInstanceInTsg = () => Boolean(stateRef.current.auth?.instances?.every(inst => inst?.status !== RUNNING))
export const tsgAccessAvail = () => !noTsgAccess() && !isIPRestricted() // consider && noRunningInstanceInTsg()

export const globalAndTsgAvail = () => globalAvail() && !noTsgAccess()

export const clearOidcSessionStorage = () => {
  for (const key of Object.keys(sessionStorage)) {
    if (key.startsWith(OIDC_STORE_PREFIX)) {
      sessionStorage.removeItem(key)
    }
  }
}

const ddTiming = {} as Record<string, number>
export const addDataDogTimingOnce = (name: string, value: number) => {
  const dd = __isLocalhost || ddTiming.DISABLED ? undefined : getDatadogRum()
  if (dd && !ddTiming[name]) {
    dd.addTiming(name, value)
    ddTiming[name] = value
  }
}

const disableTiming = () => {
  if (!ddTiming.DISABLED) {
    Object.defineProperties(ddTiming, { DISABLED: { value: 'alert' } })
  }
}
export const alertAndDisableTiming = (msg: string) => {
  disableTiming()
  window.alert(msg)
}
export const confirmAndDisableTiming = (msg: string) => {
  disableTiming()
  return window.confirm(msg)
}
